import { Directive, HostListener } from "@angular/core";

@Directive({
  selector: 'input[type="number"]',
})
export class IgnoreWheelDirective {
  ngOnInit() {
    //console.log("Ayyyyyy");
  }

  @HostListener("wheel", ["$event"])
  @HostListener("scroll", ["$event"])
  onWheel(event: Event) {
    console.log("Nope!");
    event.preventDefault();
  }
}
